import React from 'react';

import {
  ConditionalRender,
  Stack,
  Typography,
  useDeviceTypeDetection,
} from '@crossnokaye/ux-common';

import { AnimaticShelf as AnimaticShelfType, AnimaticShelfKind } from '@repo/sdk/models/components';

import { getAnimaticShelfConfigs } from './animatic-shelf.helpers';
import { AnimaticShelfIcons, IconShelfSkeletons } from './animatic-shelf-icons';
import { AnimaticShelfValues, ValueShelfSkeletons } from './animatic-shelf-values';

type AnimaticShelfProps = {
  animaticShelf?: AnimaticShelfType;
};

export const AnimaticShelf = ({ animaticShelf }: AnimaticShelfProps): React.ReactNode => {
  const { isMobile } = useDeviceTypeDetection();
  const shelfConfigs = getAnimaticShelfConfigs(animaticShelf);
  if (!shelfConfigs) {
    return null;
  }
  const { kind, icons, values, title } = shelfConfigs;

  const Skeletons = kind === AnimaticShelfKind.Icon ? IconShelfSkeletons : ValueShelfSkeletons;

  // If there are no icons or values, don't render the shelf.
  if (icons.length === 0 && values.length === 0) {
    return null;
  }

  return (
    <ConditionalRender condition={!!kind} fallback={<Skeletons />}>
      <Stack className="w-full" gap="sm">
        <ConditionalRender condition={!!title}>
          <Typography variant={'h4'} className="uppercase text-muted-foreground">
            {title}
          </Typography>
        </ConditionalRender>
        {kind === AnimaticShelfKind.Icon ? (
          <AnimaticShelfIcons icons={icons} isMobile={isMobile} />
        ) : (
          <AnimaticShelfValues values={values} isMobile={isMobile} />
        )}
      </Stack>
    </ConditionalRender>
  );
};
